<template>
  <v-combobox
    v-model="selectedCategories"
    :items="categoryOptions"
    :search-input.sync="categorySearch"
    prepend-icon="mdi-shape"
    hide-selected
    :label="
      $t(
        'components.documents.documentCategoriesAutocomplete.addDocumentCategories'
      )
    "
    multiple
    persistent-hint
    chips
    deletable-chips
    color="primary"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            v-html="
              $t(
                'components.documents.documentCategoriesAutocomplete.noResultsMatchingPressEnterToCreateANewOne',
                { categorySearch: categorySearch }
              )
            "
          >
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
import api from "@/utils/api";

export default {
  name: "DocumentCategoriesAutocomplete",
  props: ["categories"],
  data: () => ({
    categorySearch: "",
    categoryOptions: [],
  }),
  computed: {
    selectedCategories: {
      get: function () {
        return this.categories;
      },
      set: function (value) {
        this.$emit("update:categories", value);
      },
    },
  },
  created() {
    api.documentCategoriesAutocomplete("").then((resp) => {
      resp.data.forEach((element) => {
        this.categoryOptions.push(element);
      });
    });
  },
};
</script>
